module.exports = __webpack_public_path__ + "static/media/Big-Boost-Two-Lines-BG-Blue-600x600.0f1378e5.png";